import { createEmotionSsrAdvancedApproach } from 'tss-react/next/pagesDir'

export const { withAppEmotionCache, augmentDocumentWithEmotionCache } =
  createEmotionSsrAdvancedApproach({ key: 'mui', prepend: true })
